const NotFound = () => {
    return (
        <div>
            <h2>
                Oops! Page not found.
            </h2>
        </div>
    );
}
 
export default NotFound;